import { render } from "./base-left.vue?vue&type=template&id=f053ff5e&scoped=true"
import script from "./base-left.vue?vue&type=script&lang=js"
export * from "./base-left.vue?vue&type=script&lang=js"

import "./base-left.vue?vue&type=style&index=0&id=f053ff5e&lang=scss&scoped=true"

import exportComponent from "D:\\Afwct\\emis2.0\\emis-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f053ff5e"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QItem,QItemSection,QIcon,QItemLabel,QScrollArea,QList,QSeparator});qInstall(script, 'directives', {Ripple});
